import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../../../../services/redux/types";

export const selectStaticState = (state: RootState) => state.staticTokenState;

export const selectTokens = createSelector(
  selectStaticState,
  (state) => state.tokens ?? []
);

export const selectLoading = createSelector(
  selectStaticState,
  (state) => state.isLoading
);
